import styled, { css } from "styled-components";
import PropTypes from "prop-types";
import { COLORS } from "styled/colors";
import Icon from "./icon";

const Chip = ({
  size = "medium",
  color = "secondary",
  variant = "filled",
  margin = [0, 0, 0, 0],
  className = "",
  title = "",
  onRemove,
  testId = "chip",
}) => {
  const wrapperClassName = className || variant;
  return (
    <StyledChip
      className={`chip-${wrapperClassName}`}
      margin={margin}
      size={size}
      variant={variant}
      color={color}
      data-testid={testId}
    >
      {title}
      {onRemove && (
        <StyledClear onClick={() => onRemove()}>
          <Icon name="close" />
        </StyledClear>
      )}
    </StyledChip>
  );
};

const StyledClear = styled.span`
  margin-left: 8px;
  font-size: 12px;
  cursor: pointer;
`;

const StyledChip = styled.span`
  display: inline-block;
  border-width: 1px;
  border-style: solid;
  white-space: nowrap;
  ${(props) =>
    props.variant === "filled" &&
    css`
      border-color: ${COLORS.transparent};
      color: ${COLORS.text.white};
    `};
  ${(props) =>
    props.color === "primary" &&
    props.variant === "outlined" &&
    css`
      color: ${COLORS.text.primary};
      border-color: ${COLORS.border.primary};
    `};
  ${(props) =>
    props.color === "secondary" &&
    props.variant === "outlined" &&
    css`
      color: ${COLORS.text.gray700};
      border-color: ${COLORS.background.gray300};
    `};
  ${(props) =>
    props.color === "info" &&
    props.variant === "outlined" &&
    css`
      color: ${COLORS.text.info};
      border-color: ${COLORS.border.info};
    `};
  ${(props) =>
    props.color === "success" &&
    props.variant === "outlined" &&
    css`
      color: ${COLORS.text.success};
      border-color: ${COLORS.border.success};
    `};
  ${(props) =>
    props.color === "error" &&
    props.variant === "outlined" &&
    css`
      color: ${COLORS.text.error};
      border-color: ${COLORS.border.error};
    `};
  ${(props) =>
    props.color === "warning" &&
    props.variant === "outlined" &&
    css`
      color: ${COLORS.text.warning};
      border-color: ${COLORS.border.warning};
    `};
  ${(props) =>
    props.color === "primary" &&
    props.variant === "filled" &&
    css`
      color: ${COLORS.text.white};
      background: ${COLORS.background.primary};
    `};
  ${(props) =>
    props.color === "secondary" &&
    props.variant === "filled" &&
    css`
      color: ${COLORS.text.gray700};
      background: ${COLORS.background.gray200};
    `};
  ${(props) =>
    props.color === "info" &&
    props.variant === "filled" &&
    css`
      background: ${COLORS.background.info};
    `};
  ${(props) =>
    props.color === "success" &&
    props.variant === "filled" &&
    css`
      background: ${COLORS.background.success};
    `};
  ${(props) =>
    props.color === "error" &&
    props.variant === "filled" &&
    css`
      background: ${COLORS.background.error};
    `};
  ${(props) =>
    props.color === "warning" &&
    props.variant === "filled" &&
    css`
      background: ${COLORS.background.warning};
    `};
  ${(props) =>
    props.size === "small" &&
    css`
      font-size: 12px;
      line-height: 18px;
      padding: 0 8px;
      border-radius: 9px;
    `};
  ${(props) =>
    props.size === "medium" &&
    css`
      font-size: 16px;
      line-height: 24px;
      padding: 0 12px;
      border-radius: 12px;
    `};
  ${(props) =>
    props.margin &&
    css`
      margin-top: ${props.margin[0]}px;
      margin-right: ${props.margin[1]}px;
      margin-bottom: ${props.margin[2]}px;
      margin-left: ${props.margin[3]}px;
    `}
`;

Chip.propTypes = {
  margin: PropTypes.arrayOf(PropTypes.number),
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "error",
    "warning",
  ]),
  variant: PropTypes.oneOf(["filled", "outlined"]),
  size: PropTypes.oneOf(["small", "medium", "large"]),
  className: PropTypes.string,
  onRemove: PropTypes.func,
};

export default Chip;
